(() => {
  if (window.risePdpInlineMediaLoaded) return;
  window.risePdpInlineMediaLoaded = true;
  const pause = (root) => root.querySelectorAll('video').forEach((video) => video.pause());
  const visible = (node) => node.getClientRects().length > 0;
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  function enhance(root = document) {
    root.querySelectorAll('.rpm-media video').forEach((video) => {
      if (video.parentElement.classList.contains('rpm-video-frame')) return;
      const frame = document.createElement('div');
      frame.className = 'rpm-video-frame';
      video.before(frame); frame.append(video);
      const play = document.createElement('button');
      play.type = 'button'; play.className = 'rpm-play';
      play.setAttribute('aria-label', (video.getAttribute('aria-label') || '動画') + 'を再生');
      play.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor"><path d="M6 3.5 21 12 6 20.5Z"/></svg>';
      frame.append(play);
      video.controls = false;
      play.addEventListener('click', () => {
        document.querySelectorAll('.rpm-media video').forEach((other) => { if (other !== video) other.pause(); });
        video.play().catch(() => { play.hidden = true; video.controls = true; video.focus(); });
      });
      video.addEventListener('play', () => { play.hidden = true; video.controls = true; });
      video.addEventListener('pause', () => { play.hidden = false; });
      video.addEventListener('ended', () => { play.hidden = false; });
    });
    root.querySelectorAll('[data-rpm-gallery]').forEach((gallery) => {
      if (gallery.dataset.ready) return;
      const strip = gallery.querySelector('.rpm-slides');
      if (!strip) return;
      gallery.dataset.ready = 'true';
      const slides = [...strip.children];
      const prev = gallery.querySelector('[data-rpm-prev]');
      const next = gallery.querySelector('[data-rpm-next]');
      const count = gallery.querySelector('[data-rpm-count]');
      let active = 0;
      const update = () => {
        if (!strip.clientWidth) return;
        const step = slides[1] ? slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left : strip.clientWidth;
        active = Math.max(0, Math.min(slides.length - 1, Math.round(strip.scrollLeft / step)));
        count.textContent = `${active + 1} / ${slides.length}`;
        prev.disabled = active === 0; next.disabled = active === slides.length - 1;
        slides.forEach((slide, index) => { if (index !== active) pause(slide); });
      };
      const move = (amount) => {
        const index = Math.max(0, Math.min(slides.length - 1, active + amount));
        const step = slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
        strip.scrollTo({left: step * index, behavior: motion()});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      strip.addEventListener('scroll', update, {passive:true});
      strip.addEventListener('keydown', (event) => {
        if (event.target !== strip) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      new ResizeObserver(update).observe(strip);
      update();
    });
  }
  document.addEventListener('click', (event) => {
    const photoChoice = event.target.closest('[data-rpm-photo]');
    if (photoChoice) {
      const gallery = photoChoice.closest('[data-rpm-gallery]');
      const selected = Number(photoChoice.dataset.rpmPhoto);
      gallery.querySelectorAll(':scope > [data-rpm-zoom]').forEach((photo, index) => { photo.hidden = index !== selected; });
      gallery.querySelectorAll('[data-rpm-photo]').forEach((choice) => { choice.setAttribute('aria-pressed', String(choice === photoChoice)); });
      return;
    }
    const zoom = event.target.closest('[data-rpm-zoom]');
    if (zoom) {
      let viewer = document.querySelector('.rpm-photo-dialog');
      if (!viewer) {
        viewer = document.createElement('dialog');
        viewer.className = 'rpm-photo-dialog';
        viewer.setAttribute('aria-label', '実物写真・着用写真の拡大');
        viewer.innerHTML = '<div class="rpm-photo-toolbar"><p></p><button type="button" aria-label="拡大写真を閉じる">閉じる ×</button></div><img alt="">';
        document.body.append(viewer);
        viewer.querySelector('button').addEventListener('click', () => viewer.close());
        viewer.addEventListener('close', () => document.body.classList.remove('rpm-photo-viewing'));
        viewer.addEventListener('click', (e) => { if (e.target === viewer) { const r=viewer.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)viewer.close(); } });
      }
      const image = zoom.querySelector('img');
      viewer.querySelector('img').src = image.currentSrc || image.src;
      viewer.querySelector('img').alt = image.alt;
      viewer.querySelector('p').textContent = image.alt;
      viewer.showModal();
      document.body.classList.add('rpm-photo-viewing');
      return;
    }
    const opener = event.target.closest('[data-rpm-open]');
    if (opener) {
      const panel = [...document.querySelectorAll('details[data-rpm-kind]')].find((item) => item.dataset.rpmKind === opener.dataset.rpmOpen && visible(item));
      if (panel) {
        event.preventDefault(); panel.open = true;
        panel.querySelector('summary').focus({preventScroll:true});
        panel.scrollIntoView({block:'center',behavior:motion()});
      }
    }
    const close = event.target.closest('[data-rpm-close]');
    if (close) {
      const panel = close.closest('details[data-rpm-kind]');
      if (panel) { panel.open = false; panel.querySelector('summary').focus({preventScroll:true}); panel.scrollIntoView({block:'center',behavior:motion()}); }
    }
  });
  document.addEventListener('toggle', (event) => {
    if (event.target instanceof HTMLDetailsElement && !event.target.open && event.target.querySelector('.rpm-media, .rpm-video-frame')) pause(event.target);
  }, true);
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance());
  else enhance();
})();
